import axios from '../../api';

const BASE_URL = process.env.REACT_APP_URL || 'http://localhost:5100';
const BASE = `${BASE_URL}/sk-penetapan`;

export const getSkPenetapanList = (params = {}) => axios.get(BASE, { params });
export const getSkPenetapanActive = (jenisBantuan) => axios.get(`${BASE}/active`, { params: { jenisBantuan } });
export const createSkPenetapan = (formData) =>
  axios.post(BASE, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateSkPenetapan = (id, formData) =>
  axios.put(`${BASE}/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteSkPenetapan = (id) => axios.delete(`${BASE}/${id}`);
